/**
 * Created by rickborst on 27/07/2017.
 */

import {
    ActionTypes,
    BackgroundColors
} from 'store/actions/widgets/header';

const defaultState = {
        backgroundColor: BackgroundColors.DEFAULT
    },

    /**
     * Sets the background color state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setBackgroundColor = function (state, action) {

        return {
            ...state,
            backgroundColor: action.color
        };
    },

    /**
     * Contains the header state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    header = function (state = defaultState, action) {

        switch (action.type) {

            case ActionTypes.SET_HEADER_BACKGROUND_COLOR:
                return (state = setBackgroundColor(state, action));


            case ActionTypes.SET_LAST_HEADER_DATA:
                return {
                    ...state,
                    lastHeaderData: action.lastHeaderData
                };
            case ActionTypes.SET_CHANNEL_TOP_MENU:
                return {
                    ...state,
                    channelTopMenu: action.channelTopMenu
                };

            default:
                return state;
        }
    };

export default header;


// WEBPACK FOOTER //
// ./src/js/store/reducers/widgets/header.js